import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Eyebrow } from '../Eyebrow';
import { urls } from '../../data/site';
export function QuoteIntro() {
  return <section aria-labelledby="quote-heading" className="bg-ink text-paper" data-id="element-344" data-mp="30n5pkmq1jokc">
      <div className="mx-auto max-w-[1320px] px-5 pb-12 pt-6 sm:px-8 md:pb-16 md:pt-8 lg:px-12" data-id="element-345" data-mp="2mph9rtatz7m5">
        <a href={urls.home} className="group inline-flex min-h-[44px] items-center gap-2 text-[14px] font-semibold text-steel-light transition-colors duration-150 ease-out hover:text-paper" data-id="element-346" data-mp="2rmz8kqv4w6gf">
          <ArrowLeftIcon aria-hidden="true" className="h-4 w-4 transition-transform duration-150 ease-out group-hover:-translate-x-0.5" data-id="element-347" data-mp="2hsh3pidze4v1" />
          Back to home
        </a>
        <div className="mt-8 grid gap-6 md:mt-10 lg:grid-cols-12 lg:items-end lg:gap-12" data-id="element-348" data-mp="1u11st1852f86">
          <div className="lg:col-span-7" data-id="element-349" data-mp="1u3ebxhpmuvmt">
            <Eyebrow tone="dark" data-id="element-350" data-mp="1yz3cnode2ikp">Motor City Truck Collision · Brighton, MI</Eyebrow>
            <h1 id="quote-heading" className="mt-5 font-display text-[52px] font-bold uppercase leading-[0.9] sm:text-[68px] md:text-[84px]" data-id="element-351" data-mp="2iaye9nnrfggu">
              Request a Quote
            </h1>
          </div>
          <div className="max-w-[32rem] lg:col-span-5 lg:pb-2" data-id="element-352" data-mp="2rbd3uz7rbhq5">
            <p className="text-[18px] leading-relaxed text-paper md:text-[19px]" data-id="element-353" data-mp="2nab2abqdatl0">
              Tell us about your vehicle or equipment and the work you have in mind.
            </p>
            <p className="mt-2 text-[16px] leading-relaxed text-steel-light" data-id="element-354" data-mp="1umf8bes6nfrx">
              Requests can cover collision repairs, bodywork, commercial painting or restoration.
            </p>
          </div>
        </div>
      </div>
    </section>;
}